import { getRequest, postRequest, putRequest, deleteRequest } from 'config/Axios/baseConfig';
import {
  BpmByNDCAndJobTypeResponse,
  BpmByNDCAndJobTypeSingleResponse,
  BpmByNDCAndJobTypePayload
} from 'Interfaces/ReferenceInterfaces/StandardAndRecipeBpmInterface';

export const standardAndRecipeBpmServices = {
  getAllStandardAndRecipeBpms: (page = 1, pageSize = 100): Promise<BpmByNDCAndJobTypeResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<BpmByNDCAndJobTypeResponse>(
          `pps/standard-and-recipe-bpms?page=${page}&page_size=${pageSize}`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getStandardAndRecipeBpmById: (id: number): Promise<BpmByNDCAndJobTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await getRequest<BpmByNDCAndJobTypeSingleResponse>(
          `pps/standard-and-recipe-bpms/${id}/`
        );
        resolve(data);
      } catch (error) {
        reject(error);
      }
    });
  },

  createStandardAndRecipeBpm: (
    standardAndRecipeBpmData: BpmByNDCAndJobTypePayload
  ): Promise<BpmByNDCAndJobTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await postRequest<BpmByNDCAndJobTypeSingleResponse>(
          'pps/standard-and-recipe-bpms/',
          standardAndRecipeBpmData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  updateStandardAndRecipeBpm: (
    id: number,
    standardAndRecipeBpmData: BpmByNDCAndJobTypePayload
  ): Promise<BpmByNDCAndJobTypeSingleResponse> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await putRequest<BpmByNDCAndJobTypeSingleResponse>(
          `pps/standard-and-recipe-bpms/${id}/`,
          standardAndRecipeBpmData
        );
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  },

  deleteStandardAndRecipeBpm: (id: number): Promise<any> => {
    return new Promise(async (resolve, reject) => {
      try {
        const { data } = await deleteRequest(`pps/standard-and-recipe-bpms/${id}/`);
        resolve(data);
      } catch (error: any) {
        // If the error has a response with data, resolve with that data
        if (error.response?.data) {
          resolve(error.response.data);
        } else {
          reject(error);
        }
      }
    });
  }
};
